'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getColorByIndex;

var _styleguide = require('../../styles/base/_styleguide.scss');

var _styleguide2 = _interopRequireDefault(_styleguide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hexToRGB(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);

  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
}

function getColorByIndex(index) {
  var baseChartColors = Object.keys(_styleguide2.default).filter(function (color) {
    return color.indexOf('chart-') > -1;
  }).map(function (color) {
    return _styleguide2.default[color];
  });

  var colorsCount = baseChartColors.length;

  return hexToRGB(baseChartColors[index % colorsCount], 1 - Math.floor(index / colorsCount) * 0.2);
}